import { IconDefinition } from '../../types';

const BrowserLight: IconDefinition = {
  name: 'browser-ight',
  definition: {
    viewBox: '0 0 24 24',
    pathData:
      'M21.75 1.5H2.25C1.00781 1.5 0 2.50781 0 3.75V20.25C0 21.4922 1.00781 22.5 2.25 22.5H21.75C22.9922 22.5 24 21.4922 24 20.25V3.75C24 2.50781 22.9922 1.5 21.75 1.5ZM1.5 3.75C1.5 3.3375 1.8375 3 2.25 3H4.5V6H1.5V3.75ZM22.5 20.25C22.5 20.6625 22.1625 21 21.75 21H2.25C1.8375 21 1.5 20.6625 1.5 20.25V7.5H22.5V20.25ZM22.5 6H6V3H21.75C22.1625 3 22.5 3.3375 22.5 3.75V6Z'
  }
};

export default BrowserLight;
